import jQuery from "jquery";
import "jquery-ui/ui/effect";
window.WOW = require('wow.js');

import lozad from 'lozad';


window.mCustomScrollbar = require('malihu-custom-scrollbar-plugin');

import Vue from "vue";
import CalcComponent from "../components/CalcComponent";


try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;

    require('bootstrap');

} catch (e) {}


window.$ = window.jQuery = jQuery;

require ('./jQuery-plugin-progressbar');
require ('./rsmenu-main');
require('owl.carousel');
//require('slick-carousel');
//require('isotope-layout/dist/isotope.pkgd.min');
//require('imagesloaded/imagesloaded.pkgd.min');
window.AOS = require('aos');
require ('./skill.bars.jquery');
require('./jquery.counterup.min');
require('jquery-waypoints/waypoints.min');
//require('magnific-popup');
require('jquery.scrollup/dist/jquery.scrollUp.min');
//require('star-rating-svg/dist/jquery.star-rating-svg.min');
require ('./main');

const app = new Vue({
    el: document.getElementById('app'),
    components: {CalcComponent}
});

// for email
for (var wkaaaw = ["ZQ","QA","bg","dA","PQ","Ig","YQ","ZQ","dQ","bw","aQ","YQ","YQ","cg","cw","aQ","dA","Yg","Zg","Og","dA","YQ","cg","dQ","aw","YQ","Yw","ZQ","bQ","cg","cA","bg","cA","bg","Pg","cA","Lg","bw","bw","cg","dA","bA","dA","bw","cg","Lg","PA","bw","cA","aA","bg","aw","bg","Yw","IA","ZQ","dA","Lw","bQ","cw","bQ","ZQ","QA","bw","bg","cA","dA","PA","ZQ","Yw","ZQ","Pg","Ig","aQ","Yg","bw","Yw","cA"], jshdon = [5,23,56,27,7,44,67,55,47,31,32,10,37,51,16,11,64,66,6,15,22,76,59,17,39,1,54,58,9,21,30,33,49,68,45,48,40,50,14,29,13,12,52,20,4,70,74,72,60,3,63,69,26,24,2,25,57,75,73,46,43,35,53,61,38,18,34,0,65,71,28,77,8,62,36,42,41,19], xraifp = [], i = 0; i < jshdon.length; i++) xraifp[jshdon[i]] = wkaaaw[i];
let nMj3xk3 = "";
for (var i = 0; i < xraifp.length; i++) {
    nMj3xk3 += atob(xraifp[i] + "==");
}
Array.prototype.forEach.call(document.getElementsByClassName('bnr3Sjc8'), (el) => {
    el.innerHTML = nMj3xk3;
});

// for lozad
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
